import React from 'react'
import moment from 'moment-timezone'

export function changeNameByEndDate (campaign) {
  // if (endDate < +moment())
  return <div>
      { campaign.end_date && campaign.end_date < moment().unix() && <span className='color-red'>[PAST END DATE] </span> }
      { campaign.name }
    </div>
}